import type {
  AudioPluginEditorConfig,
  FilePluginEditorConfig,
  GalleryPluginEditorConfig,
} from '@wix/ricos';

import { FILE_URLS } from './fileMockURL';
import { testAudio, testImages } from './mock-data';

type ImageUploadFunc = Exclude<GalleryPluginEditorConfig['handleFileSelection'], undefined>;

export const mockImageUploadFunc: ImageUploadFunc = (
  _index,
  _multiple,
  updateEntity,
  _removeEntity,
  componentData
) => {
  const count = componentData?.items ? [1, 2, 3] : [1];
  const data: any[] = [];
  count.forEach(_ => {
    const testItem = testImages[Math.floor(Math.random() * testImages.length)];
    data.push({
      id: testItem.photoId,
      original_file_name: testItem.url,
      file_name: testItem.url,
      width: testItem.metadata.width,
      height: testItem.metadata.height,
    });
  });

  setTimeout(() => {
    updateEntity({ data });
  }, 500);
};

type FileUploadFunc = Exclude<FilePluginEditorConfig['handleFileSelection'], undefined>;

export const mockFileUploadFunc: FileUploadFunc = updateEntity => {
  const filenames = ['image.jpg', 'document.pdf', 'music.mp3'];
  const name = filenames[Math.floor(Math.random() * filenames.length)];
  let type;
  if (name && name.includes('.')) {
    type = name.split('.').pop();
  }
  const data = [
    {
      name,
      type,
      url: FILE_URLS[type],
      size: 150000,
    },
  ];
  setTimeout(() => updateEntity({ data }), 500);
};

export const mockHandleFileUpload = (file, updateEntity) => {
  const fileUrl = window.URL.createObjectURL(file);

  setTimeout(() => {
    const img = new Image(); // Create an Image object
    img.src = fileUrl;

    img.onload = () => {
      const width = img.naturalWidth;
      const height = img.naturalHeight;

      updateEntity({
        data: {
          file_name: fileUrl,
          width,
          height,
        },
      });
    };
  }, 500);
};

type AudioUploadFunc = Exclude<AudioPluginEditorConfig['handleFileSelection'], undefined>;

export const mockCustomAudioUploadFunc: AudioUploadFunc = (
  updateEntity,
  _removeEntity,
  fromSettings,
  componentData
) => {
  // eslint-disable-next-line no-console
  console.log('consumer wants to upload custom audio');

  // for uploading cover image from the settings modal:
  if (fromSettings) {
    return mockImageUploadFunc(
      undefined,
      false,
      ({ data }) => {
        const coverImage = data?.[0] || testImages[0];
        updateEntity({ data: coverImage as any });
      },
      undefined,
      componentData
    );
  }

  setTimeout(() => {
    updateEntity({ data: testAudio[0] });
    // eslint-disable-next-line no-console
    console.log('consumer uploaded', testAudio[0]);
  }, 500);
};
